import axiosInstance from "../data/apiClient";

// Fetch all magazines
export async function fetchMagazines() {
  const response = await axiosInstance.get("/api/Magazine");
  return response.data;
}

// Fetch magazine by ID
export async function fetchMagazineById(id) {
  const response = await axiosInstance.get(`/api/Magazine/${id}`);
  return response.data;
}

// Fetch magazines by type (optional endpoint support)
export async function fetchMagazinesByType(type) {
  const response = await axiosInstance.get(`/api/Magazine/type/${type}`);
  return response.data;
}

// Fetch magazine categories for sidebar
export async function fetchCategories() {
  const response = await axiosInstance.get("/api/Magazine/categories");
  return response.data;
}

// Fetch recent magazines by category (optional)
export async function fetchRecentMagazines(category) {
  const response = await axiosInstance.get(`/api/Magazine/recent/${category}`);
  return response.data;
}

// Trigger file download (PDF)
export function downloadMagazine(fileId) {
  const url = `${axiosInstance.defaults.baseURL}api/Magazine/download/${fileId}`;
  window.open(url, "_blank");
}
